<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm">

                    <!-- Commentaires de correction pour cette étape -->
            <div v-if="isInCorrectionMode && bescComments.length > 0" class="alert alert-warning mb-4 border-start border-warning border-4">
                <h6 class="text-warning fw-bold mb-3">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    Corrections demandées pour cette étape ({{ bescComments.length }})
                </h6>
                
                <div class="comments-list">
                    <div v-for="comment in bescComments" :key="comment.id" 
                        class="card mb-2 border-warning">
                        <div class="card-body p-3">
                            <div class="d-flex align-items-start gap-2 mb-2">
                                <i class="fas fa-comment-dots text-warning fa-lg"></i>
                                <div class="flex-grow-1">
                                    <strong class="text-dark d-block mb-1">Agent validateur :</strong>
                                    <p class="mb-0">{{ comment.commentText }}</p>
                                    <small class="text-muted d-block mt-2">
                                        <i class="fas fa-clock me-1"></i>
                                        {{ formatDateTime(comment.createdAt) }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        <div class="card-header d-flex justify-content-between align-items-center py-4 px-4"
            style="background-color: #0a59a4;">
            <div>
                <h3 class="text-white fw-bold mb-1">Étape 1/3 – Informations de base du BESC</h3>
                <small class="text-white opacity-75">Remplissez ou modifiez les informations générales du
                    bordereau</small>
            </div>
        </div>

        <div class="card-body p-15 p-sm-20 p-md-30 letter-spacing">
            <!-- Indicateur de chargement -->
            <div v-if="loadingBesc" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Chargement...</span>
                </div>
                <p class="mt-3 text-muted">Chargement des données...</p>
            </div>
            <Form :initial-values="formData" @submit="EditSaveStep1">
                <div class="section-title mb-4">
                    <h5 class="text-primary fw-bold border-bottom pb-2">Parties prenantes</h5>
                </div>
                <div class="row g-3 mb-4">
                    <div class="col-md-4">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="text-black fw-semibold mb-0"> Importateur / Destinataire
                                <span class="text-danger">*</span>
                            </label>
                            <a href="#" class="btn btn-primary btn-sm"
                                @click.prevent="openActeurModal('importateur', 'Importateur')"
                                title="Ajouter un nouvel importateur">
                                <i class="flaticon-plus"></i>
                            </a>
                        </div>
                        <Field name="importateur" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.importateur" 
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.importateur = val
                                    const acteur = acteursParType.importateur.find(a => a.value === val?.value);
                                    if (acteur?.refActeur) {
                                        const result = await checkBlacklist('PERSON', acteur.refActeur);
                                        blacklistAlerts.importateur = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.importateur = null;
                                    }
                                }" 
                                value-prop="value" 
                                :object="true" 
                                :options="acteursParType.importateur"
                                :searchable="true" 
                                :loading="loadingActeurs" 
                                placeholder="Rechercher un importateur..."
                                label="label" 
                                track-by="value" />
                        </Field>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="text-black fw-semibold mb-0"> Partie à notifier
                                <span class="text-danger">*</span>
                            </label>
                            <a href="#" class="btn btn-primary btn-sm"
                                @click.prevent="openActeurModal('partieANotifier', 'Partie à notifier')"
                                title="Ajouter une partie à notifier">
                                <i class="flaticon-plus"></i>
                            </a>
                        </div>
                        <Field name="partieANotifier" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.partieANotifier" 
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.partieANotifier = val
                                    const acteur = acteursParType.partie_a_notifier.find(a => a.value === val?.value);
                                    if (acteur?.refActeur) {
                                        const result = await checkBlacklist('PERSON', acteur.refActeur);
                                        blacklistAlerts.partieANotifier = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.partieANotifier = null;
                                    }
                                }" 
                                value-prop="value" 
                                :object="true" 
                                :options="acteursParType.partie_a_notifier"
                                :searchable="true" 
                                :loading="loadingActeurs" 
                                placeholder="Rechercher une partie..."
                                label="label" 
                                track-by="value" />
                        </Field>
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            Transitaire <span class="text-danger">*</span>
                        </label>

                        <Field name="transitaire" v-slot="{ field }">
                            <input 
                                v-if="isTransitaire"
                                type="text" 
                                class="form-control shadow-sm bg-light text-muted" 
                                :disabled="true"
                                :value="transitaireNom"
                            />
                            
                            <Multiselect
                                v-else
                                :model-value="formData.transitaire"
                                @update:model-value="val => {
                                    field.onChange(val)
                                    formData.transitaire = val
                                }"
                                :options="usersTransitaires"
                                :searchable="true"
                                :loading="loadingTransitaires"
                                placeholder="Rechercher un transitaire..."
                                label="label"
                                track-by="value"
                                value-prop="value"
                                :object="true"
                            />
                        </Field>

                        <ErrorMessage name="transitaire" class="text-danger d-block mt-1" />
                    </div>

                    <div class="col-md-4">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="text-black fw-semibold mb-0"> Incoterm </label>
                            <span></span>
                        </div>
                        <Field name="incoterm" v-slot="{ setValue, errorMessage }">
                            <Multiselect :model-value="formData.incoterm" @update:model-value="val => {
                                setValue(val)
                                formData.incoterm = val
                            }" :options="incoterms" value-prop="value" :object="true" placeholder="Sélectionner"
                                label="label" track-by="value" />
                            <small v-if="errorMessage" class="text-danger d-block mt-1">{{ errorMessage }}</small>
                        </Field>
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            Pays d'origine <span class="text-danger">*</span>
                        </label>
                        <Field name="paysOrigine" v-slot="{ setValue, errorMessage }">
                            <Multiselect :model-value="formData.paysOrigine" @update:model-value="val => {
                                setValue(val)
                                formData.paysOrigine = val
                            }" :options="pays" value-prop="value" :object="true" :searchable="true" :loading="loading"
                                placeholder="Rechercher..." label="label" track-by="value" />
                            <small v-if="errorMessage" class="text-danger d-block mt-1">{{ errorMessage }}</small>
                        </Field>
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            Paiement du fret <span class="text-danger">*</span>
                        </label>
                        <Field name="typeFret" v-slot="{ setValue, errorMessage }">
                            <Multiselect :model-value="formData.typeFret" @update:model-value="val => {
                                setValue(val)
                                formData.typeFret = val
                            }" value-prop="value" :object="true" :options="paiementFret" :loading="loading"
                                placeholder="Sélectionner" label="label" track-by="value" />
                            <small v-if="errorMessage" class="text-danger d-block mt-1">{{ errorMessage }}</small>
                        </Field>
                    </div>
                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            Numéro de BL / Connaissement <span class="text-danger">*</span>
                        </label>
                        <Field name="numeroConnaissement" type="text" class="form-control shadow-sm"
                            placeholder="ex: MSCU123456789" v-model="formData.numeroConnaissement" />
                        <ErrorMessage name="numeroConnaissement" class="text-danger d-block mt-1" />
                    </div>

                    <!-- Alerte globale pour les parties prenantes -->
                    <div class="col-md-12" v-if="blacklistAlerts.importateur || blacklistAlerts.partieANotifier">
                        <div class="alert alert-danger text-center py-3 px-4 mt-3">
                            <h6 class="fw-bold mb-3">
                                <i class="ph-warning-circle fs-4"></i> ⚠️ ALERTE BLACKLIST - PARTIES PRENANTES
                            </h6>
                            <div class="text-start">
                                <ul class="mb-0">
                                    <li v-if="blacklistAlerts.importateur" class="mb-2">
                                        <strong>Importateur:</strong> Liste {{ blacklistAlerts.importateur.list_code }} - {{ blacklistAlerts.importateur.reason }}
                                    </li>
                                    <li v-if="blacklistAlerts.partieANotifier" class="mb-2">
                                        <strong>Partie à notifier:</strong> Liste {{ blacklistAlerts.partieANotifier.list_code }} - {{ blacklistAlerts.partieANotifier.reason }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-title mb-4 mt-5">
                    <h5 class="text-primary fw-bold border-bottom pb-2">Informations transport & itinéraire</h5>
                </div>
                <div class="row g-3 mb-4">

                    <div class="col-md-4">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="text-black fw-semibold mb-0"> Transporteur
                                <span class="text-danger">*</span>
                            </label>
                            <a href="#" class="btn btn-primary btn-sm"
                                @click.prevent="openActeurModal('transporteur', 'Transporteur')"
                                title="Ajouter un nouvel transporteur">
                                <i class="flaticon-plus"></i>
                            </a>
                        </div>
                        <Field name="transporteur" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.transporteur" 
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.transporteur = val
                                    const acteur = acteursParType.transporteur.find(a => a.value === val?.value);
                                    if (acteur?.refActeur) {
                                        const result = await checkBlacklist('PERSON', acteur.refActeur);
                                        blacklistAlerts.transporteur = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.transporteur = null;
                                    }
                                }" 
                                value-prop="value" 
                                :object="true" 
                                :options="acteursParType.transporteur"
                                :searchable="true" 
                                :loading="loadingActeurs" 
                                placeholder="Rechercher un transporteur..."
                                label="label" 
                                track-by="value" />
                        </Field>
                    </div>
                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">Navire</label>
                        <Field name="vessel" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.vessel" 
                                value-prop="value" 
                                :object="true"
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.vessel = val
                                    const navire = navires.find(n => n.value === val?.value);
                                    if (navire?.imo) {
                                        const result = await checkBlacklist('SHIP', navire.imo);
                                        blacklistAlerts.vessel = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.vessel = null;
                                    }
                                }" 
                                :options="navires" 
                                :searchable="true" 
                                :loading="loadingNavires"
                                placeholder="Rechercher (IMO ou MMSI)..." 
                                label="label" 
                                track-by="value"
                                @search-change="searchNavire" 
                                :filter-results="false" 
                                :min-chars="2" />
                        </Field>
                    </div>
                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">Transbordement</label>
                        <Field name="transbordement" v-model="formData.transbordement" type="radio">
                            <div class="d-flex gap-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="transbordementOui" value="oui"
                                        v-model="formData.transbordement" />
                                    <label class="form-check-label" for="transbordementOui">Oui</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="transbordementNon" value="non"
                                        v-model="formData.transbordement" />
                                    <label class="form-check-label" for="transbordementNon">Non</label>
                                </div>
                            </div>
                        </Field>
                    </div>
                    <div class="col-md-4" v-if="showTransbordementFields">
                        <label class="d-block text-black fw-semibold mb-2">Navire après transbordement</label>
                        <Field name="navireApresTransbordement" v-slot="{ setValue }">
                            <Multiselect :model-value="formData.navireApresTransbordement" @update:model-value="val => {
                                setValue(val)
                                formData.navireApresTransbordement = val
                            }" :options="navires" value-prop="value" :object="true" :searchable="true"
                                :loading="loadingNavires" placeholder="Rechercher (IMO ou MMSI)..." label="label"
                                track-by="value" @search-change="searchNavire" :filter-results="false" :min-chars="2" />
                        </Field>
                    </div>

                    <div class="col-md-4" v-if="showTransbordementFields">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="text-black fw-semibold mb-0"> Transporteur après transbordement
                                <span class="text-danger">*</span>
                            </label>
                            <a href="#" class="btn btn-primary btn-sm"
                                @click.prevent="openActeurModal('transporteurApresTransbordement', 'Après transbordement')"
                                title="Ajouter un nouvel transporteur après transbordement">
                                <i class="flaticon-plus"></i>
                            </a>
                        </div>
                        <Field name="transporteurApresTransbordement" v-slot="{ setValue }">
                            <Multiselect :model-value="formData.transporteurApresTransbordement" @update:model-value="val => {
                                setValue(val)
                                formData.transporteurApresTransbordement = val
                            }" :options="acteursParType.transporteurApresTransbordement" :searchable="true"
                                value-prop="value" :object="true" :loading="loadingActeurs"
                                placeholder="Rechercher un transporteurApresTransbordement..." label="label"
                                track-by="value" />
                        </Field>
                    </div>
                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            Port de chargement <span class="text-danger">*</span>
                        </label>
                        <Field name="portChargement" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.portChargement" 
                                value-prop="value" 
                                :object="true"
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.portChargement = val
                                    const port = ports.find(p => p.value === val?.value);
                                    if (port?.locode) {
                                        const result = await checkBlacklist('PORT', port.locode);
                                        blacklistAlerts.portChargement = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.portChargement = null;
                                    }
                                }" 
                                :options="ports" 
                                :searchable="true" 
                                :loading="loadingPorts"
                                placeholder="Rechercher (nomPort ou locode)..." 
                                label="label" 
                                track-by="value"
                                @search-change="searchPort" 
                                :filter-results="false" 
                                :min-chars="2" />
                            <ErrorMessage name="portChargement" class="text-danger d-block mt-1" />
                        </Field>
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            Port de déchargement <span class="text-danger">*</span>
                        </label>
                        <Field name="portDechargement" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.portDechargement" 
                                value-prop="value" 
                                :object="true"
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.portDechargement = val
                                    const port = ports.find(p => p.value === val?.value);
                                    if (port?.locode) {
                                        const result = await checkBlacklist('PORT', port.locode);
                                        blacklistAlerts.portDechargement = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.portDechargement = null;
                                    }
                                }" 
                                :options="ports" 
                                :searchable="true" 
                                :loading="loadingPorts"
                                placeholder="Rechercher (nomPort ou locode)..." 
                                label="label" 
                                track-by="value"
                                @search-change="searchPort" 
                                :filter-results="false" 
                                :min-chars="2" />
                            <ErrorMessage name="portDechargement" class="text-danger d-block mt-1" />
                        </Field>
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">Destination finale</label>
                        <Field name="destinationFinale" v-slot="{ setValue }">
                            <Multiselect 
                                :model-value="formData.destinationFinale" 
                                @update:model-value="async val => {
                                    setValue(val)
                                    formData.destinationFinale = val
                                    const paysObj = pays.find(p => p.value === val?.value);
                                    if (paysObj?.iso2_code) {
                                        const result = await checkBlacklist('COUNTRY', paysObj.iso2_code);
                                        blacklistAlerts.destinationFinale = result.isBlacklisted ? result.details : null;
                                    } else {
                                        blacklistAlerts.destinationFinale = null;
                                    }
                                }" 
                                :options="pays" 
                                value-prop="value" 
                                :object="true" 
                                :searchable="true" 
                                :loading="loading"
                                placeholder="Rechercher..." 
                                label="label" 
                                track-by="value" />
                        </Field>
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            ETD (Date de Départ estimé) <span class="text-danger">*</span>
                        </label>
                        <Field name="etd" type="date" class="form-control shadow-sm" :min="today"
                            v-model="formData.etd" />
                        <ErrorMessage name="etd" class="text-danger d-block mt-1" />
                    </div>

                    <div class="col-md-4">
                        <label class="d-block text-black fw-semibold mb-2">
                            ETA (Date d'Arrivée estimée) <span class="text-danger">*</span>
                        </label>
                        <Field name="eta" type="date" class="form-control shadow-sm" :min="form.etd || today"
                            v-model="formData.eta" />
                        <ErrorMessage name="eta" class="text-danger d-block mt-1" />
                    </div>

                    <!-- Alerte globale pour transport & itinéraire -->
                    <div class="col-md-12" v-if="blacklistAlerts.transporteur || blacklistAlerts.vessel || blacklistAlerts.portChargement || blacklistAlerts.portDechargement || blacklistAlerts.destinationFinale">
                        <div class="alert alert-danger text-center py-3 px-4 mt-3">
                            <h6 class="fw-bold mb-3">
                                <i class="ph-warning-circle fs-4"></i> ⚠️ ALERTE BLACKLIST - TRANSPORT & ITINÉRAIRE
                            </h6>
                            <div class="text-start">
                                <ul class="mb-0">
                                    <li v-if="blacklistAlerts.transporteur" class="mb-2">
                                        <strong>Transporteur:</strong> Liste {{ blacklistAlerts.transporteur.list_code }} - {{ blacklistAlerts.transporteur.reason }}
                                    </li>
                                    <li v-if="blacklistAlerts.vessel" class="mb-2">
                                        <strong>Navire:</strong> Liste {{ blacklistAlerts.vessel.list_code }} - {{ blacklistAlerts.vessel.reason }}
                                    </li>
                                    <li v-if="blacklistAlerts.portChargement" class="mb-2">
                                        <strong>Port de chargement:</strong> Liste {{ blacklistAlerts.portChargement.list_code }} - {{ blacklistAlerts.portChargement.reason }}
                                    </li>
                                    <li v-if="blacklistAlerts.portDechargement" class="mb-2">
                                        <strong>Port de déchargement:</strong> Liste {{ blacklistAlerts.portDechargement.list_code }} - {{ blacklistAlerts.portDechargement.reason }}
                                    </li>
                                    <li v-if="blacklistAlerts.destinationFinale" class="mb-2">
                                        <strong>Destination finale:</strong> Liste {{ blacklistAlerts.destinationFinale.list_code }} - {{ blacklistAlerts.destinationFinale.reason }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
                    <router-link to="/liste-besc" class="btn btn-danger px-4">Annuler</router-link>
                    <button type="submit" class="btn btn-primary px-5 py-2 text-white" :disabled="loading">
                        {{ loading ? 'Enregistrement...' : 'Mettre à jour & Passer à l\'étape 2' }}
                    </button>
                </div>
            </Form>
            <ActeurModal :key="currentTypeActeurId" v-model="showActeurModal" :field-to-fill="currentActeurField"
                :type-acteur-id="currentTypeActeurId" @created="onActeurCreated" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, reactive, watch } from 'vue'
import { Form, Field, ErrorMessage, useForm } from 'vee-validate'
import Multiselect from '@vueform/multiselect'
import * as Yup from 'yup'
import ApiService from '@/services/ApiService'
import { success, error, warning } from '@/utils/utils'
import { bescWizard, resetBescWizard } from '@/utils/bescWizard'
import { useRouter, useRoute } from 'vue-router'

import { Besc } from '@/models/Besc'
import ActeurModal from '../AddBesc/ActeurModal.vue'
import { toast } from 'sonner'
import JwtService from "@/services/JwtService"



interface Correction {
    id: string;
    status: 'OPEN' | 'RESOLVED';
    fields_concerned?: string;
    message_to_requester?: string;
}

export default defineComponent({
    name: 'EditBescStep1',
    components: { Form, Field, ErrorMessage, Multiselect, ActeurModal },
    setup() {
        const router = useRouter()
        const route = useRoute()
        const loading = ref(false)
        const loadingBesc = ref(false)
        const loadingPorts = ref(false)
        const loadingActeurs = ref(false)
        const showActeurModal = ref(false)
        const currentActeurField = ref<string | null>(null)
        const showTransbordementFields = ref(false)
        const { setFieldValue } = useForm()
        const today = new Date().toISOString().split('T')[0]
        const currentTypeActeurId = ref<string>('')
        const form = bescWizard.step1
        const bescId = route.params.id as string;
        const corrections = ref<Correction[]>([]);
        const bescComments = ref<any[]>([]); // Commentaires pour l'étape 1 (BESC_FILE)
        const correctionRequest = ref<any>(null);
        const besc = ref<any>({}) // Pour stocker les données du BESC
        const isInCorrectionMode = computed(() => 
            ['PENDING_CORRECTION', 'CORRECTIONS_IN_PROGRESS'].includes(besc.value?.currentStatus?.code)
        )

        const currentUser = JwtService.getUser()
        const roles = ref<Array<string>>(JwtService.getRole())
        const checkRole = (name: string) => roles.value.includes(name)
        const isTransitaire = computed(() => checkRole('Transitaire'))
        
        const usersTransitaires = ref<Array<{ label: string; value: number }>>([])
        const loadingTransitaires = ref(false)
        const transitaireNom = ref('')

        // Alertes blacklist
        const blacklistAlerts = ref<{
            importateur: any;
            expediteur: any;
            transporteur: any;
            partieANotifier: any;
            paysOrigine: any;
            destinationFinale: any;
            portChargement: any;
            portDechargement: any;
            vessel: any;
            navireApresTransbordement: any;
        }>({
            importateur: null,
            expediteur: null,
            transporteur: null,
            partieANotifier: null,
            paysOrigine: null,
            destinationFinale: null,
            portChargement: null,
            portDechargement: null,
            vessel: null,
            navireApresTransbordement: null
        })

        const formatDate = (dateString: string) => {
            if (!dateString) return "";
            return dateString.split("T")[0];
        };

        const formatDateTime = (dateString: string) => {
            if (!dateString) return "";
            return new Date(dateString).toLocaleString('fr-FR');
        };



          

        interface FormDataType {
            importateur: { value: string; label: string } | null;
            partieANotifier: { value: string; label: string } | null;
            transitaire: { value: string; label: string } | null;
            expediteur: { value: string; label: string } | null;
            incoterm: { value: string; label: string } | null;
            paysOrigine: { value: string; label: string } | null;
            typeFret: { value: string; label: string } | null;
            numeroConnaissement: string;
            transporteur: { value: string; label: string } | null;
            vessel: { value: string; label: string } | null;
            navireApresTransbordement: { value: string; label: string } | null;
            transporteurApresTransbordement: { value: string; label: string } | null;
            portChargement: { value: string; label: string } | null;
            portDechargement: { value: string; label: string } | null;
            destinationFinale: { value: string; label: string } | null;
            etd: string;
            eta: string;
            transbordement: 'oui' | 'non' | ''
        }

        const formData = reactive<FormDataType>({
            importateur: null,
            partieANotifier: null,
            transitaire: null,
            expediteur: null,
            incoterm: null,
            paysOrigine: null,
            typeFret: null,
            numeroConnaissement: "",
            transporteur: null,
            vessel: null,
            navireApresTransbordement: null,
            transporteurApresTransbordement: null,
            portChargement: null,
            portDechargement: null,
            destinationFinale: null,
            etd: "",
            eta: "",
            transbordement: ''

        })
        watch(
            () => formData.transbordement,
            (newValue) => {
                showTransbordementFields.value = newValue === 'oui'
            },
            { immediate: true } 
        )
        const acteursParType = ref<Record<string, any[]>>({
            importateur: [],
            transitaire: [],
            expediteur: [],
            partie_a_notifier: [],
            transporteur: [],
            transporteurApresTransbordement: []
        })

        const transbordementOptions = ref([
            { label: 'Oui', value: 'oui' },
            { label: 'Non', value: 'non' }
        ])


        const incoterms = ref([])
        const pays = ref([])
        const paiementFret = ref([])
        const navires = ref<Array<{ label: string; value: number; imo?: string }>>([])
        const ports = ref<Array<{ label: string; value: number }>>([])
        const acteurs = ref<Array<{ label: string; value: number; refActeur?: string }>>([])
        const typeActeurs = ref<Map<string, string>>(new Map())
        const loadingNavires = ref(false)
        let searchTimeout: ReturnType<typeof setTimeout> | null = null
        const isEditMode = computed(() => !!bescWizard.bescId)

        const populateFormForEdit = (bescData: any) => {
            Object.keys(form).forEach(key => {
                if (bescData[key] !== undefined && bescData[key] !== null) {
                    form[key] = bescData[key]
                }
            })
            showTransbordementFields.value = bescData.transbordement === 'oui'
        }

        const fetchBescData = async (id: string) => {
            loadingBesc.value = true
            try {
                const response = await ApiService.get(`/besc/${id}`)
                const bescData = response.data.data

                console.log(' BESC récupéré:', bescData)

                if (bescData.importateur) form.importateur = bescData.importateur
                if (bescData.partieANotifier) form.partieANotifier = bescData.partieANotifier
                if (bescData.transitaire) form.transitaire = bescData.transitaire
                if (bescData.expediteur) form.expediteur = bescData.expediteur
                if (bescData.transporteur) form.transporteur = bescData.transporteur
                if (bescData.numeroConnaissement) form.numeroConnaissement = bescData.numeroConnaissement
                if (bescData.incoterm) form.incoterm = bescData.incoterm
                if (bescData.paysOrigine) form.paysOrigine = bescData.paysOrigine
                if (bescData.typeFret) form.typeFret = bescData.typeFret
                if (bescData.destinationFinale) form.destinationFinale = bescData.destinationFinale
                if (bescData.vessel) form.vessel = bescData.vessel
                if (bescData.portChargement) form.portChargement = bescData.portChargement
                if (bescData.portDechargement) form.portDechargement = bescData.portDechargement
                if (bescData.transbordement) form.transbordement = bescData.transbordement
                if (bescData.navireApresTransbordement) form.navireApresTransbordement = bescData.navireApresTransbordement
                if (bescData.transporteurApresTransbordement) form.transporteurApresTransbordement = bescData.transporteurApresTransbordement
                if (bescData.etd) form.etd = bescData.etd
                if (bescData.eta) form.eta = bescData.eta

                if (bescData.transbordement === 'oui') {
                    showTransbordementFields.value = true
                }

                if (bescData.vessel) {
                    await loadNavireOption(bescData.vessel)
                }
                if (bescData.navireApresTransbordement) {
                    await loadNavireOption(bescData.navireApresTransbordement)
                }
                if (bescData.portChargement) {
                    await loadPortOption(bescData.portChargement)
                }
                if (bescData.portDechargement) {
                    await loadPortOption(bescData.portDechargement)
                }

                success('Données chargées avec succès !')
            } catch (err: any) {
                console.error(' Erreur lors de la récupération du BESC:', err)
                error('Impossible de charger les données du BESC')
            } finally {
                loadingBesc.value = false
            }
        }

        const loadNavireOption = async (naviresId: number) => {
            try {
                const response = await ApiService.get(`/vessels/${naviresId}`)
                const navire = response.data.data

                const option = {
                    label: `${navire.name} - ${navire.mmsi} - ${navire.imo}`,
                    value: navire.id
                }

                if (!navires.value.find(n => n.value === navire.id)) {
                    navires.value.push(option)
                }
            } catch (err) {
                console.error('Erreur chargement navire:', err)
            }
        }

        const loadPortOption = async (portId: number) => {
            try {
                const response = await ApiService.get(`/Liste/port/${portId}`)
                const port = response.data.data

                const option = {
                    label: `${port.nomPort} - ${port.locode}`,
                    value: port.id
                }

                if (!ports.value.find(p => p.value === port.id)) {
                    ports.value.push(option)
                }
            } catch (err) {
                console.error('Erreur chargement port:', err)
            }
        }

        const fetchTypeActeurs = async () => {
            try {
                const response = await ApiService.get('/typeActeurs')
                const typeActeursList = response.data.data.data

                typeActeursList.forEach((t: any) => {
                    typeActeurs.value.set(t.libelle.toLowerCase(), t.id)
                })

                console.log("Types acteurs chargés:", typeActeurs.value)
            } catch (err) {
                error('Erreur chargement types acteurs')
            }
        }

        const fetchActeurs = async () => {
            loadingActeurs.value = true
            try {
                const { data } = await ApiService.get('/acteurs')
                const liste = data.data.data.map((a: any) => {
                    return {
                        label: a.nomComplet,
                        value: a.id,
                        typeId: a.typeActeur?.id,
                        typeLibelle: a.typeActeur?.libelle,
                        refActeur: a.refActeur
                    }
                })
                liste.forEach((a: any) => {
                    const libelle = a.typeLibelle?.toLowerCase()

                    if (!libelle) {
                        console.warn('Acteur SANS type:', a)
                        return
                    }

                    if (libelle.includes('importateur')) {
                        acteursParType.value.importateur.push(a)
                    }
                    if (libelle.includes('transitaire')) {
                        acteursParType.value.transitaire.push(a)
                    }
                    if (libelle.includes('expéditeur') || libelle.includes('expediteur')) {
                        acteursParType.value.expediteur.push(a)
                    }
                    if (libelle.includes('partie') || libelle.includes('notifier')) {
                        acteursParType.value.partie_a_notifier.push(a)
                    }
                    if (libelle.includes('transporteur')) {
                        acteursParType.value.transporteur.push(a)
                        acteursParType.value.transporteurApresTransbordement.push(a)
                    }
                })

            } catch (err: any) {
                console.error('ERREUR fetchActeurs:', err)
                error('Erreur chargement acteurs')
            } finally {
                loadingActeurs.value = false
            }
        }
        const getBescStep1 = async (id: string) => {
            try {
                const response = await ApiService.get(`/besc/${id}`);
                const donnees = response.data.data;
                besc.value = donnees; // Stocker les données du BESC
                console.log("Step1", response.data.data)
                if (donnees.bescActeurs && Array.isArray(donnees.bescActeurs)) {
                    donnees.bescActeurs.forEach((item: any) => {
                        const acteur = item.acteur
                        if (!acteur || !acteur.typeActeur) return

                        const option = {
                            value: acteur.id,
                            label: acteur.nomComplet,
                            typeId: acteur.typeActeur?.id,
                            typeLibelle: acteur.typeActeur?.libelle
                        }

                        const role = acteur.typeActeur.libelle.toLowerCase()

                        if (role.includes('importateur')) {
                            if (!acteursParType.value.importateur.find(a => a.value === acteur.id)) {
                                acteursParType.value.importateur.push(option)
                            }
                            formData.importateur = option
                        }

                        if (role.includes('partie à notifier')) {
                            if (!acteursParType.value.partie_a_notifier.find(a => a.value === acteur.id)) {
                                acteursParType.value.partie_a_notifier.push(option)
                            }
                            formData.partieANotifier = option
                        }



                        if (role.includes('expediteur')) {
                            if (!acteursParType.value.expediteur.find(a => a.value === acteur.id)) {
                                acteursParType.value.expediteur.push(option)
                            }
                            formData.expediteur = option
                        }

                        if (role.includes('transporteur')) {
                            if (!acteursParType.value.transporteur.find(a => a.value === acteur.id)) {
                                acteursParType.value.transporteur.push(option)
                                acteursParType.value.transporteurApresTransbordement.push(option) // même liste
                            }
                            formData.transporteur = option
                            if (formData.transbordement === 'oui') {
                                formData.transporteurApresTransbordement = option
                            }
                        }
                    })
                }

                // Gérer le transitaire comme un utilisateur
                if (donnees.transitaire) {
                    const transitaireUser = donnees.transitaire
                    formData.transitaire = {
                        value: transitaireUser.id,
                        label: `${transitaireUser.prenom} ${transitaireUser.nom}`
                    }
                    
                    // Ajouter à la liste si pas déjà présent
                    if (!usersTransitaires.value.find(u => u.value === transitaireUser.id)) {
                        usersTransitaires.value.push({
                            value: transitaireUser.id,
                            label: `${transitaireUser.prenom} ${transitaireUser.nom}`
                        })
                    }
                }

                formData.numeroConnaissement = donnees.numeroConnaissement;
                formData.etd = formatDate(donnees.etd);
                formData.eta = formatDate(donnees.eta);

                formData.incoterm = donnees.incoterm ? {
                    value: donnees.incoterm.id,
                    label: donnees.incoterm.libelle
                } : null;

                formData.paysOrigine = donnees.paysOrigine ? {
                    value: donnees.paysOrigine.id,
                    label: donnees.paysOrigine.name_fr
                } : null;

                formData.typeFret = donnees.typeFret ? {
                    value: donnees.typeFret.id,
                    label: donnees.typeFret.libelle
                } : null;

                formData.vessel = donnees.vessel ? {
                    value: donnees.vessel.id,
                    label: donnees.vessel.name
                } : null;

                formData.portChargement = donnees.portChargement ? {
                    value: donnees.portChargement.id,
                    label: donnees.portChargement.nomPort
                } : null;

                formData.portDechargement = donnees.portDechargement ? {
                    value: donnees.portDechargement.id,
                    label: donnees.portDechargement.nomPort
                } : null;

                formData.destinationFinale = donnees.destinationFinalePays
                    ? {
                        value: donnees.destinationFinalePays.id,
                        label: donnees.destinationFinalePays.name_fr
                    }
                    : null;

                formData.transbordement = donnees.transbordement?.toLowerCase() === 'oui' ? 'oui' : 'non';
                formData.navireApresTransbordement = donnees.navireApresTransbordement
                    ? {
                        value: donnees.navireApresTransbordement.id,
                        label: donnees.navireApresTransbordement.name
                    }
                    : null;
                if (formData.transbordement === 'oui' && formData.transporteur) {
                    formData.transporteurApresTransbordement = formData.transporteur
                }
               success("Les données de l'étape 1 sont chargées avec succès");
            } catch (err: any) {
                error(err.response?.data?.message || "Erreur lors du chargement");

            }
        }

        const EditSaveStep1 = async () => {
            try {
                const payload = {
                    numeroConnaissement: formData.numeroConnaissement,
                    etd: formData.etd || null,
                    eta: formData.eta || null,
                    incoterm: formData.incoterm?.value,
                    paysOrigine: formData.paysOrigine?.value,
                    typeFret: formData.typeFret?.value,
                    vessel: formData.vessel?.value,
                    navireApresTransbordement: formData.navireApresTransbordement?.value,
                    portChargement: formData.portChargement?.value,
                    portDechargement: formData.portDechargement?.value,
                    destinationFinalePays: formData.destinationFinale?.value,
                    transbordement: formData.transbordement || null,
                    importateur: formData.importateur?.value || null,
                    partieANotifier: formData.partieANotifier?.value || null,
                    transitaire: formData.transitaire?.value || null,
                    transporteur: formData.transporteur?.value || null,

                };
                console.log("Payload FINAL :", payload);
                await ApiService.put(`/besc/${bescId}`, payload);
                success("Modification Etape 1 réussie !");
                router.push({ name: 'EditAddBescStep2', params: { id: bescId } })
            } catch (err: any) {
                error(err.response?.data?.message || "Échec de la modification");
            }
        }
        const fetchPaimentFret = async () => {
            try {
                const { data } = await ApiService.get("/type-fret-paiements")
                paiementFret.value = data.data.data.map((tf: any) => ({
                    label: tf.libelle,
                    value: tf.id
                }))
            } catch (err: any) {
                error(err.response?.data?.message || 'Erreur type fret')
            }
        }

        const fetchRequestCorrection = async () => {
                try {
                    const { data } = await ApiService.get(`/corrections/besc/${bescId}`)
                    console.log("dattaaaa",data);

                    corrections.value = data.data.filter((cor: any) => cor.status === 'OPEN')
                    
                    // Ensuite, récupérer les commentaires depuis les validationtasks
                    const correctionWithTask = data.data.find((cor: any) => cor.validationtasks)
                    
                    if (correctionWithTask && correctionWithTask.validationtasks && correctionWithTask.validationtasks.validationcomments) {
                        const allComments = correctionWithTask.validationtasks.validationcomments || []
                        
                        // Récupérer seulement les commentaires de l'étape 1 (BESC)
                        bescComments.value = allComments.filter((comment: any) => 
                            comment.relatedEntityType === 'BESC' && 
                            comment.visibility === 'EXTERNAL'
                        )

                        console.log(`${bescComments.value.length} commentaire(s) chargé(s) pour l'étape 1 (BESC)`)
                        console.log("Commentaires BESC récupérés:", bescComments.value)
                    }
                    
                } catch(err: any) {
                    error(err.response?.data?.message || 'Erreur de récupération')
                }
            }

       


        const openActeurModal = (fieldName: string, typeLibelle: string) => {
            const typeId = typeActeurs.value.get(typeLibelle.toLowerCase())

            if (!typeId) {
                warning(
                    `Le type d'acteur "${typeLibelle}" n'existe pas encore dans le système. ` +
                    `Veuillez d'abord créer ce type d'acteur dans la section de gestion des types avant de pouvoir ajouter des acteurs de ce type.`
                )
                return
            }
            currentActeurField.value = fieldName
            currentTypeActeurId.value = typeId
            showActeurModal.value = true
        }

        const onActeurCreated = ({ acteur, field }: { acteur: any; field: string | null }) => {
            if (!field) return

            const listes = {
                importateur: acteursParType.value.importateur,
                partieANotifier: acteursParType.value.partie_a_notifier,
                transitaire: acteursParType.value.transitaire,
                expediteur: acteursParType.value.expediteur,
                transporteur: acteursParType.value.transporteur,
                transporteurApresTransbordement: acteursParType.value.transporteurApresTransbordement
            }
            if (field in listes) {
                listes[field as keyof typeof listes].push(acteur)
            }

            form[field as keyof Besc] = acteur.value
            setFieldValue(field, acteur.value)

            currentActeurField.value = null
        }

        const fetchIncoterm = async () => {
            try {
                const { data } = await ApiService.get("/incoterms")
                incoterms.value = data.data.data.map((inco: any) => ({
                    label: `${inco.code} - ${inco.libelle}`,
                    value: inco.id
                }))
            } catch (err: any) {
                error(err.response?.data?.message || 'Erreur incoterms')
            }
        }

        const searchNavire = async (query: string) => {
            if (searchTimeout) {
                clearTimeout(searchTimeout)
            }

            if (!query || query.length < 2) {
                navires.value = []
                return
            }

            searchTimeout = setTimeout(async () => {
                loadingNavires.value = true

                try {
                    const response = await ApiService.get(`/vessels?search=${encodeURIComponent(query)}`)
                    const naviresData = response.data?.data || []

                    navires.value = naviresData.map((navire: any) => ({
                        label: `${navire.name} - ${navire.mmsi} - ${navire.imo}`,
                        value: navire.id,
                        imo: navire.imo
                    }))

                } catch (err: any) {
                    console.error('Erreur recherche navires:', err)
                    error('Impossible de rechercher les navires')
                    navires.value = []
                } finally {
                    loadingNavires.value = false
                }
            }, 300)
        }

        const searchPort = async (query: string) => {
            if (searchTimeout) {
                clearTimeout(searchTimeout)
            }

            if (!query || query.length < 2) {
                ports.value = []
                return
            }

            searchTimeout = setTimeout(async () => {
                loadingPorts.value = true

                try {
                    const response = await ApiService.get(`/Liste/port?search=${encodeURIComponent(query)}`)
                    const portsData = response.data?.data || []

                    ports.value = portsData.map((port: any) => ({
                        label: `${port.nomPort} - ${port.locode}`,
                        value: port.id,
                        locode: port.locode
                    }))

                } catch (err: any) {
                    console.error('Erreur recherche ports:', err)
                    error('Impossible de rechercher les ports')
                    ports.value = []
                } finally {
                    loadingPorts.value = false
                }
            }, 300)
        }

        const fetchPays = async () => {
            try {
                const { data } = await ApiService.get("/pays")
                pays.value = data.data.data.map((p: any) => ({
                    label: p.name_fr,
                    value: p.id,
                    iso2_code: p.iso2_code
                }))
            } catch (err) {
                console.warn("Endpoint /pays non trouvé ou erreur")
            }
        }

        const checkBlacklist = async (type: string, referenceValue: string) => {
            try {
                const response = await ApiService.get(
                    `/regulatory/check?entry_type=${type}&reference_value=${referenceValue}`
                );
                return response.data.data;
            } catch (err) {
                console.error('Erreur vérification blacklist:', err);
                return { isBlacklisted: false, details: null };
            }
        }

        const fetchUsersTransitaires = async () => {
            loadingTransitaires.value = true
            try {
                const { data } = await ApiService.get('/users/by-role?role=Transitaire')
                console.log('Réponse transitaires:', data)

                usersTransitaires.value = data.data.data.map((u: any) => ({
                    label: `${u.prenom} ${u.nom}`,
                    value: u.id
                }))
            } catch (err) {
                error('Erreur chargement transitaires')
            } finally {
                loadingTransitaires.value = false
            }
        }

        onMounted(async () => {
            await fetchTypeActeurs()
            await fetchActeurs()
            await fetchUsersTransitaires()
            fetchPaimentFret()
            fetchIncoterm()
            fetchPays()

            if (isTransitaire.value) {
                const prenom = JwtService.getUserName() || ''
                const nom = JwtService.getUserLastName() || ''
                const user = JwtService.getUser()
                
                transitaireNom.value = `${prenom} ${nom}`.trim()
                
                formData.transitaire = { value: user?.userId || '', label: transitaireNom.value }
                
                console.log('✓ Transitaire nom:', transitaireNom.value)
                console.log('✓ Transitaire ID:', user?.userId)
            }

            const idFromRoute = route.params.id as string | undefined
            if (idFromRoute) {
                bescWizard.bescId = idFromRoute
                await getBescStep1(idFromRoute)
                await fetchRequestCorrection()
            } else {
                resetBescWizard()
            }
        })
        return {
            form,
            formData,
            loading,
            loadingBesc,
            loadingActeurs,
            today,
            transbordementOptions,
            incoterms,
            pays,
            paiementFret,
            navires,
            ports,
            EditSaveStep1,
            setFieldValue,
            acteurs,
            showActeurModal,
            fetchActeurs,
            onActeurCreated,
            openActeurModal,
            currentActeurField,
            currentTypeActeurId,
            acteursParType,
            isEditMode,
            showTransbordementFields,
            loadingNavires,
            searchNavire,
            searchPort,
            loadingPorts,
            corrections,
            bescComments,
            besc,
            isInCorrectionMode,
            formatDateTime,
            blacklistAlerts,
            checkBlacklist,
            isTransitaire,
            usersTransitaires,
            loadingTransitaires,
            transitaireNom
        }
    }
})
</script>